import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import { MoonIcon } from '@/components/common/Icons';
import { Switch } from '@/components/common/Switch';

export default function ThemeSwitchItem() {
	// TODO: useTheme here
	const { t } = useTranslation();

	return (
		<div className="p-2.5 flex items-center gap-x-3 relative">
			<MoonIcon />
			<div className="text-md font-bold text-secondary-black">
				{t('common:darkMode')}
			</div>
			<Switch />
		</div>
	);
}
